// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3FdhU","box":"box__pRc9w","window":"window__1Yeez"};